var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intell"},[(_vm.showIntell)?_c('IntellIgent',{on:{"message":_vm.controlIntell}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }